import React from 'react';
import get from 'lodash.get';

const styles = {
  indicator: {
    height: '24px',
    width: '24px',
    borderRadius: '50%',
  },
  green: {
    backgroundColor: 'green',
  },
  red: {
    backgroundColor: 'red',
  },
};

export default ({ source, record = {} }) => (
  <div style={{ ...get(record, source) ? styles.green : styles.red, ...styles.indicator }} />
);
